// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".roDguhge>*+*{margin-top:max(2rem,min(2.92vw,3.5rem))}.xrqIECxk{align-items:center;display:flex;justify-content:space-between}.xrqIECxk>*+*{margin-left:2.5rem}@media(max-width:667.98px){.xrqIECxk{display:block}.xrqIECxk>*+*{margin-left:0;margin-top:1.25rem}}.Ki3\\+5k6b{font-size:1.25rem;line-height:.88;max-width:40rem;text-transform:uppercase;text-wrap:balance}.Ki3\\+5k6b span{color:#bf2333}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"container": "roDguhge",
	"footer": "xrqIECxk",
	"footerText": "Ki3+5k6b"
};
module.exports = ___CSS_LOADER_EXPORT___;
